import React from 'react';

const Appointoption = ({ option, setTreatment }) => {
    const { name, price, slots } = option;
    return (
        <div className="card  shadow-xl">
            <div className="card-body text-center mt-10">
                <h2 className="text-2xl text-primary text-center">{name}</h2>
                <p>{slots.length > 0 ? slots[0] : 'Try Another day'}</p>
                <p>{slots.length}{slots.length > 1 ? 'space' : 'space'} Available</p>
                <p><small>Price : $ {price}</small></p>
                <div className="card-actions justify-center">

                    <label
                        disabled={slots.length === 0}
                        onClick={() => setTreatment(option)} htmlFor="Booking-modal" className="btn btn-primary bg-gradient-to-r from-primary to-secondary text-white font-bold">Book Appointment
                    </label>
                </div>
            </div>
        </div>
    );
};

export default Appointoption;